const apiOmni: string = window.AppMode === 'app' ? 'https://storeapp.toyotainventory.com.au/' : (window.AppMode === 'tpr' ? 'https://tpr-store-app-service.azurewebsites.net/' : 'https://stagingstoreapp.toyotainventory.com.au/');

const api = window.AppMode === 'app' ? 'https://app.toyotainventory.com.au/api/' : (window.AppMode === 'tpr' ? 'https://tpr-toyotainventory-app-service.azurewebsites.net/api/' : 'https://stagingapp.toyotainventory.com.au/api/')

const Api = {
	returnSpecialOfferUrl(): string {
		return apiOmni + 'reservation/v2/myToyotaOfferAvailable';
	},
	returnPaymentPostURL(): string {
		return apiOmni + 'api/Order';
	},
	returnSensisURL(searchTerm: string) {
		if (searchTerm !== null) {
			const url = apiOmni +
				'api/sensisproxy?path=' +
				'%2Faddress%2F%3Fcountry%3DAU%26formatted_address%3D' +
				encodeURIComponent(searchTerm)
			return url;
		}
		return false;
	}, 
	returnSensisResultURL(searchResultId: string) {
		if (searchResultId !== null) {
			const url = apiOmni +
				'api/sensisproxy?path=' +
				'%2Faddress%2F' +
				searchResultId
			return url;
		}
		return false;
	}, 
	returnDealerInfoURL(dealerID: number): any {
		if (dealerID !== null) {
			const url = api +
				'DealerInfo?' +
				'id=' + dealerID +
				'&' +
				'includeOpeningTimesForNewDepartment=true'
			return url;
		}
		return false;
	},
	returnDealerAgentURL(dealerID: number): any {
		if (dealerID !== null) {
			const url = api + 'DealerStoreInfo/' + dealerID
			return url;
		}
		return false;
	}, 
	returnReserveUrl(): string{
		return apiOmni + 'reservation/v2';
	},
	returnLogActionUrl(): string {
		return apiOmni + 'reservation/v1/session';
	}
};
export default Api;